module.exports = __webpack_public_path__ + "static/media/cardBack.920e24ca.png";